<!-- <section class="w-100 float-left">
    <div class="slider_main">
        <div id="main_slider" class="carousel slide carousel-fade" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#main_slider" data-slide-to="0" class="active"></li>
                <li data-target="#main_slider" data-slide-to="1"></li>
                <li data-target="#main_slider" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item  active first_slide_bg">
                    <img class="w-100 " src="assets/images/slide1.png" alt="First slide">
                    <div class="carousel-caption">
                        <div class="container h-100 d-flex justify-content-center flex-column">
                            <div class="w-100 float-left d-flex flex-column align-items-center slider_logo">
                                <img src="assets/images/slider/slider_logo.png" class="animated zoomIn" alt="slider logo">
                            </div>
                            <div class="number_images row">
                                <div class="number_images_row col-lg-12 d-flex justify-content-center">
                                    <img src="assets/images/slider/line.png" class="animated zoomIn" alt="slider line">
                                </div>
                                <div class="number_images_row col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4">
                                    <img src="assets/images/slider/step1.png" class="animated bounceInUp d1" alt="Mobile App Development">
                                    <div class="animated bounceInUp d2">
                                        <p class="text-center">Mobile App Development</p>
                                    </div>
                                </div>

                                <div class="number_images_row col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4">
                                    <img src="assets/images/slider/step2.png" class="animated bounceInUp d3" alt="Web Development">
                                    <div class="animated bounceInUp d4">
                                        <p class="text-center">Web Development</p>
                                    </div>
                                </div>

                                <div class="number_images_row col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4">
                                    <img src="assets/images/slider/step3.png" class="animated bounceInUp d5" alt="DevOps">
                                    <div class="animated bounceInUp d6">
                                        <p class="text-center">DevOps</p>
                                    </div>
                                </div>

                                <div class="number_images_row col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 offset-md-0 offset-sm-2 offset-2">
                                    <img src="assets/images/slider/step4.png" class="animated bounceInUp d7" alt="Cloud Computing">
                                    <div class="animated bounceInUp d8">
                                        <p class="text-center">Cloud Computing</p>
                                    </div>
                                </div>

                                <div class="number_images_row col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4">
                                    <img src="assets/images/slider/step5.png" class="animated bounceInUp d9" alt="BlockChain">
                                    <div class="animated bounceInUp d10">
                                        <p class="text-center">BlockChain</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="carousel-item first_slide_bg ">
                    <img class="w-100 d-md-block d-none " src="assets/images/slide2.png" alt="second slide">
                    <div class="carousel-caption">
                        <div class="container h-100">
                            <div class="row h-100 align-items-center">
                                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12 float-left">
                                    <h5 class="slider_text_title animated bounceInDown">
                                        <span class="slider_text_title_color1">WEB APPLICATION SERVICES</span>
                                    </h5>
                                    <span class="w-100 float-left slider_small_title animated bounceInRight">We are complete full-stack web application developers.</span>

                                    <p class="slider_text animated  bounceInLeft"> Since 2011, we are delivering the best-in-class web solutions across different industry verticals. We use cutting-edge technologies to serve you with high-quality websites and web apps.</p>
                                    <div class="w-100 float-left text-md-left text-sm-center animated  bounceInUp">
                                        <button class="main_btn" routerLink="/contact-us">Click for Free Consultancy</button>
                                    </div>
                                </div>
                                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 d-md-block d-none"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="carousel-item first_slide_bg">
                    <img class="w-100 d-md-block d-none" src="assets/images/slide3.png" alt="third slide">
                    <div class="carousel-caption">
                        <div class="container h-100">
                            <div class="row h-100 align-items-center">
                                <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12 float-left">
                                    <h5 class="slider_text_title ">
                                        <span class="slider_text_title_color1 animated bounceInDown">MOBILITY</span>
                                    </h5>
                                    <span class="w-100 float-left slider_small_title animated bounceInRight">GO MOBILE GO CLOUD GO DIGITAL</span>

                                    <p class="slider_text animated bounceInLeft"> We have developed 500+ mobile apps for startups, SMEs, and established businesses worldwide. Our in-house mobile app developers can work on any size project to deliver top-notch mobility solutions.
                                    </p>
                                    <div class="w-100 float-left text-md-left text-sm-center animated  bounceInUp">
                                        <button class="main_btn" routerLink="/contact-us">Click for Free Consultancy</button></div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-md-block d-none"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="carousel-item slider_background">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 float-left slider-main-text">
                                <h5 class="slider_text_title d-flex justify-content-center align-items-center">
                                    <span class="animated bounceInDown">Mobility
                                        <span class="small_title">
                                            GO MOBILE GO CLOUD GO DIGITAL
                                        </span>
                                    </span>
                                </h5>
                                <p class="slider_text animated bounceInLeft">We have developed 500+ mobile apps
                                    for startups, SMEs, and established businesses worldwide. Our in-house mobile app
                                    developers can work on any size project to deliver top-notch mobility solutions.</p>
                                <div class="w-100 text-left"><button routerLink="/contact-us"
                                        class="main_btn animated bounceInUp">Know More</button> </div>
                            </div>
                            <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 slider_right_img float-right animated bounceInRight">
                                <img class="d-block w-100" src="assets/images/mobi.png" alt="First slide">
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</section> -->

<app-slider></app-slider>
<app-inheritx-solutions></app-inheritx-solutions>
<app-our-services></app-our-services>
<app-our-portfolio></app-our-portfolio>
<app-our-partners></app-our-partners>
<app-talk-to-our-experts></app-talk-to-our-experts>
<app-our-testimonials></app-our-testimonials>
<app-our-team></app-our-team>
<app-our-clients></app-our-clients>
<!-- <app-our-blogs></app-our-blogs> -->